import { UploadResult } from './importExportApi'

export type ImportEventMetadata = {
  total: number
  success: boolean
  message?: string | null
}

export const buildImportEventMetadata = (result: UploadResult): ImportEventMetadata => {
  const metadata: ImportEventMetadata = {
    total: result.total,
    success: result.success,
  }
  if (result.errors.length > 0) {
    metadata.message = result.errors[0].message ? result.errors[0].message : result.errors[0].propertyName
  }
  return metadata
}
